const api = {
	listClerk: '/clerk/listClerk',      //店员列表
	addClerk: '/clerk/addClerk',        //添加店员
	deleteClerk: '/clerk/deleteClerk',  //删除店员
	editClerk: '/clerk/editClerk',      //编辑店员

	listUserGroups: '/userGroup/listUserGroups', // 岗位列表
	addUserGroup: '/userGroup/addUserGroup', // 新增岗位
	editUserGroup: '/userGroup/editUserGroup', // 编辑岗位
	deleteUserGroup: '/userGroup/deleteUserGroup', // 删除岗位
	getUserGroup: '/userGroup/getUserGroup', // 获取岗位详情
	listNormalPrividges: '/userGroup/listNormalPrividges' // 获取所有的权限
};

const routes = {
	'/job-manage': '岗位管理',
	'/job-manage/detail': '岗位详情',
	'/job-manage/edit': '编辑岗位',
	'/job-manage/add': '新增岗位'
};

export { api, routes };
